import { HttpRequest, HttpMethod } from "./http";

class IssueReportProvider extends HttpRequest {
    // Create a new issue report. Server stamps reporter/version/status.
    Create(payload) {
        return this.request(HttpMethod.Post, `/api/v1/bo/issue-reports`, payload);
    }

    // List issue reports. params: { mine: 1|"all", page, per_page }
    List(params) {
        return this.request(HttpMethod.Get, `/api/v1/bo/issue-reports`, params);
    }

    // Trigger the GitHub sync engine (forward + reverse) once. Admin-gated
    // server-side. Returns { enabled, forward_created, reverse_touched }.
    Sync() {
        return this.request(HttpMethod.Post, `/api/v1/bo/issue-reports/sync`, {});
    }

    // Presign a screenshot upload. Open to any authenticated staff (unlike the
    // catalog presign, which is admin-only). Body: { file_name, content_type };
    // object_type is forced to "issue" server-side. Returns { upload_url,
    // cdn_url, object_key }.
    Presign(payload) {
        return this.request(HttpMethod.Post, `/api/v1/bo/issue-reports/uploads/presign`, payload);
    }
}

export default IssueReportProvider;
